export const RouteConstants = {
  BASE: "/",
  LOGIN: "/login",
  APPEAL: "/appeal/:id",
  NEW_APPEAL: "/newAppeal"
};
